export default __webpack_public_path__ + "static/avatar-do-3-e0ee519d6307a4ae4c0007c029dfd74a.png";